var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccommWhite1212 = function SvgAccommWhite1212(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.295 3.347V4.77c.614 0 1.105.237 1.105.947v3.044c0 .12-.101.218-.227.218h-.426l-.329.947h-.49l-.325-.947H2.402l-.33.947h-.49l-.33-.947H.828A.223.223 0 0 1 .6 8.762V5.718c0-.52.49-.947 1.105-.947V3.347c0-.521.441-.947.981-.947h6.628c.54 0 .981.426.981.947m-3.752-.119a.11.11 0 0 0-.113.11v1.324c0 .06.05.11.113.11h2.78a.11.11 0 0 0 .113-.11V3.338c0-.06-.05-.11-.113-.11zm-3.866 0a.11.11 0 0 0-.113.11v1.324c0 .06.05.11.113.11h2.78a.11.11 0 0 0 .113-.11V3.338c0-.06-.05-.11-.113-.11z",
    clipRule: "evenodd"
  })));
};
export default SvgAccommWhite1212;